import { useQuery } from '@tanstack/react-query';

import { type AirlineCarriersResponse, getAllAirlineCarriers } from '~/services/FlightsService';

export const airlineCarriersQueryKeys = {
  all: ['flights', 'airlineCarriers'] as const,
  search: (brand: string, search: string) => [...airlineCarriersQueryKeys.all, 'search', brand, search] as const,
};

export function useAirlineCarriersSearch(brand: string, debouncedSearch: string) {
  const trimmed = debouncedSearch.trim();

  return useQuery<AirlineCarriersResponse>({
    queryKey: airlineCarriersQueryKeys.search(brand, trimmed),
    queryFn: async ({ signal }) => getAllAirlineCarriers(brand, trimmed, { signal }),
    enabled: Boolean(brand && trimmed.length > 0),
  });
}
